module.exports = __webpack_public_path__ + "static/media/railway.c0f6c4c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/railway.svg
// module id = 173
// module chunks = 0